import { IWindowService } from 'angular';
import curalateModule from 'app/curalate.module';

/**
 * Curalate Mobile Installer link support.
 *
 * The `cur.lt/mobile` link redirects to to app.curalate.com/mobile-install.
 *
 * We need to boot up here, detect the user's user agent, and redirect them to the appropriate app store.
 *
 * Legacy implementation was server-side:
 * https://github.com/bvengineering/pinsights/blob/dd432ca6ce371c3f821de92a61b49d64f4d01440/pinsights-web/pinsights-web-admin/src/main/scala/bootstrap/liftweb/Boot.scala#L245-L254
 */
curalateModule.component('mobileInstallRedirect', {
  template: '<div/>',
  controller: ['$window', ($window: IWindowService) => {
    if (/android/i.test($window.navigator.userAgent)) {
      $window.location.assign('https://cur.lt/android');
    } else {
      $window.location.assign('https://cur.lt/ios');
    }
  }],
});
